// cemeteryCreate.js
import React, { useState } from 'react';
import useQueries from '../../../database/useQueries';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useContext } from 'react';
import { GlobalContext } from '../../../App';
import FormTemplate from '../../template/form/FormTemplate';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { v4 as uuidv4 } from 'uuid';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { addRecordToCache, createFetchDataServer, createFetchDataServerWithCallback, getTableData } from '../../../database/fetchData';

const NAME_ENTITY = 'מדינה';

function CountryCreate() {
  // קבלת ערכים מהסטור
  const columns = useSelector((state) => state.columnsFormCountries.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  const [loading, setLoading] = useState(true); // מצב טעינה
  const [loadingData, setLoadingData] = useState(false);

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataCountry } = useQueries();

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { value } = location.state || {};

  const { setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`הוספת מדינה`);
  }, [location.pathname]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט

  const myColumns = () => {
    return columns.map((field) => {
      let lock = false;
      return {
        ...field,
        disabled: lock ? lock : field.disabled && value !== undefined,
        required: field.required || false,
        show: field?.show || false
      };
    });
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    !loading && handleAllDataLoaded();
  }, [loading]);

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());
  };

  const handleChange = (event) => {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  };

  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach((field) => {
      if (field?.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        if (context?.contextCountries.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {

      let updatedFormValues = { ...formValues };

      setLoadingData(true);

      const unicId = uuidv4()

      let res = await addOrUpdateDataCountry(formValues, unicId);
      if (res === 200) {
        context?.setContextCountries((prev) => {
          updatedFormValues = { ...updatedFormValues, id: unicId, unicId: unicId }

          // בדיקה אם הערך קיים בסטייט
          const existingIndex = prev.findIndex((item) => item.unicId === updatedFormValues.unicId);

          addRecordToCache(updatedFormValues, 'dataCountries');

          if (existingIndex !== -1) {
            // אם הערך קיים, מעדכן אותו
            const updatedState = [...prev];
            updatedState[existingIndex] = { ...updatedState[existingIndex], ...updatedFormValues };
            return updatedState;
          } else {
            // אם הערך לא קיים, מוסיף אותו
            return [...prev, updatedFormValues];
          }
        });
        setLoadingData(false);
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCountries = localTempData.find((item) => item.name === 'dataCountries');
        if (dataCountries) {
          setLoading(false);
        }
      }
      else {
        const handlePartialUpdate = (tableName) => {
          console.log(`Partial update received for table: ${tableName}`);
          setLoading(false);
        };
        // fetchDataServerWithCallback(['countries'], token, handlePartialUpdate);
      }
    }
    loadTableData();
  }, []);

  if (loading || loadingData) return <LoadingOverlay />;

  return <FormTemplate title={`הוספת ${NAME_ENTITY}`} btn={`שמור`} fields={columns} columns={columns} formValues={formValues} handleChange={handleChange} handleSubmit={handleSubmit} errors={errors} />;
}

export default CountryCreate;
